
/* injects from baggage-loader */

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router";
import { toggleActiveClassRegion } from "../../../../actions/ui";

function CompetitionList (props) {
    const data = Object.values(props.competition).sort((a, b) => a.order - b.order);
    const handleClick = (id) => {
        return props.dispatch(toggleActiveClassRegion(parseInt(id)));
    };

    useEffect(() => {
        props.dispatch(toggleActiveClassRegion(parseInt(props.params.competitionId)))
    },[])

    return data && data.map(item =>
        !item.name.includes("Outright") && <p className="competitionList" key={item.id}>
            <Link
                to={`/${props.gameType}/${props.sportAlias}/${props.regionId}/${item.id}`}
                onClick={() => handleClick(item.id)}
                className={props.cursor === item.id ? 'active' : ''}
            >{item.name}</Link>
        </p>);
}

export default connect()(withRouter(CompetitionList));